import * as React from 'react';
import { IModalProps, Modal, ModalHeader, ModalBody, ModalFooter } from '@msdyn365-commerce-modules/utilities';
import MsDyn365 from '@msdyn365-commerce/core';

interface IOrderListShare {
    isError: boolean;
    setIsError: (val: boolean) => void;
}

const OrderListSupercededError = (props: IOrderListShare) => {
    const { isError, setIsError } = props;

    const modalPropsTerms: IModalProps = {
        applicationNode: MsDyn365.isBrowser ? document.body : '',
        isOpen: isError,
        autoFocus: true,
        size: 'sm',
        keyboard: true,
        backdrop: true,
        zIndex: 1000,
        fade: true,
        className: 'share-orderlist-modal',
        toggle: () => setIsError(false)
    };

    return (
        <Modal {...modalPropsTerms}>
            <ModalHeader closeAriaLabel='Close' closeButtonLabel='Close' toggle={() => setIsError(false)}></ModalHeader>
            <div style={{ color: '#ff2d2d', fontSize: '2rem' }}>Cannot add All Items to Cart</div>
            <ModalBody>
                <div style={{ color: '#ff2d2d', fontWeight: 500, marginTop: '3rem' }}>
                    All available items from your list have been added to cart. Your list contains some items that have been phased out, and
                    those items have not be added to cart. Click back to the list to review the phased out items and consider alternatives
                </div>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'flex-end' }}></ModalFooter>
        </Modal>
    );
};

export default OrderListSupercededError;
